import React from 'react';
import Link from 'next/link';
import cl from 'classnames';

import { ClassName, GADataType, I18nText, IsDisabled } from '../../../types';
import { IconsEnum } from '../../../assets/icons/types';

import { Icon } from '../../Icon';
import { Translate } from '../../../helpers/Translate';

type NextPureLinkHelperOnClick = (
  e: React.MouseEvent<HTMLAnchorElement>
) => void;

interface NextPureLinkHelperProps {
  className?: ClassName;
  disabled?: IsDisabled;
  download?: string;
  href: string;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  id?: string;
  onClick?: NextPureLinkHelperOnClick;
  onMouseEnter?: () => void;
  prefetch?: boolean;
  target?: '_blank';
  text?: string;
  textClassName?: ClassName;
}

function NextPureLinkHelper({
  className,
  dataGa,
  disabled,
  download,
  href,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  id,
  onClick,
  onMouseEnter,
  prefetch,
  target,
  text,
  textClassName
}: NextPureLinkHelperProps & GADataType) {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
    } else {
      onClick?.(e);
    }
  };

  return (
    <Link
      className={cl(className, { 'pointer-events-none': disabled })}
      data-ga={dataGa}
      download={download}
      href={href}
      id={id}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      prefetch={prefetch}
      tabIndex={disabled ? -1 : undefined}
      target={target}
    >
      {icon ? <Icon className={iconClassName} icon={icon} /> : null}
      {i18nText && i18nTextClassName ? (
        <span className={i18nTextClassName}>
          <Translate id={i18nText} />
        </span>
      ) : null}
      {i18nText && !i18nTextClassName ? <Translate id={i18nText} /> : null}
      {text && textClassName ? (
        <span className={textClassName}>{text}</span>
      ) : null}
      {text && !textClassName ? text : null}
    </Link>
  );
}

export default NextPureLinkHelper;
